__turbopack_context__.v({
  "className": "tomorrow_6e205510-module__oLxN5a__className",
});
